import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { getTimezone, getTimezoneAbbr } from '../utils/timezone.utils';
import { CountryService } from './country.service';

const TIMEZONE_STORAGE_KEY = '__timezone_preference';

@Injectable({
  providedIn: 'root',
})
export class TimezonePreferenceService {
  private readonly countryService = inject(CountryService);

  selectedTimezone = signal<string>(this.getInitialTimezone());
  timezoneAbbr = computed(() => getTimezoneAbbr(this.selectedTimezone()));

  constructor() {
    this.setupLocalStorageSync();
    this.setupCrossTabSync();
  }

  private getInitialTimezone(): string {
    const stored = localStorage.getItem(TIMEZONE_STORAGE_KEY);

    return this.countryService.getCanonicalTimezone(stored || getTimezone());
  }

  private setupLocalStorageSync() {
    effect(() => {
      const tz = this.selectedTimezone();
      localStorage.setItem(TIMEZONE_STORAGE_KEY, tz);
    });
  }

  private setupCrossTabSync() {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key !== TIMEZONE_STORAGE_KEY || !event.newValue) {
        return;
      }

      const timezone = this.countryService.getCanonicalTimezone(event.newValue);

      if (timezone !== this.selectedTimezone()) {
        this.selectedTimezone.set(timezone);
      }
    });
  }
}
